var _polygon, _path, _polygon2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    id: "venmo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3292C8",
    points: "12.6 10.717 12.6 10.724 12.6 10.727"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3292C8",
    d: "M1.54 9.839L0 9.987l.71 4.164h1.75c.77-1.007 1.72-2.428 1.72-3.523 0-.345-.07-.612-.24-.878l-1.4.276c.09.187.15.414.15.74 0 .602-.43 1.48-.78 2.033L1.54 9.839zM8.16 10.934c0-.681-.5-1.164-1.38-1.164-1.6 0-2.38 1.372-2.38 2.664 0 1.007.48 1.796 1.81 1.796.53 0 1.07-.109 1.42-.276l.19-1.243c-.5.247-.87.345-1.27.345-.367 0-.635-.196-.639-.681C6.732 12.365 8.16 12.019 8.16 10.934zM5.94 11.576c.04-.474.41-.819.7-.819.16 0 .3.099.3.296C6.94 11.447 6.22 11.576 5.94 11.576zM10.59 14.151h1.5l.46-2.881c.02-.156.049-.379.05-.546-.001-.571-.271-.964-1.03-.964-.57 0-.98.227-1.29.424l-.02-.345h-1.3l-.68 4.313h1.5l.48-3.029c.12-.059.32-.148.52-.148.14 0 .26.04.26.237l-.03.296L10.59 14.151zM18.45 9.76c-.57 0-.97.178-1.4.474-.16-.276-.46-.474-.94-.474-.54 0-.94.217-1.24.434l-.05-.355h-1.28l-.69 4.303h1.51l.47-3.02c.13-.059.32-.148.52-.148.15 0 .27.049.27.266l-.02.207-.43 2.704h1.5l.48-3.029c.13-.069.32-.148.5-.148.15 0 .27.049.27.266l-.02.217-.43 2.694h1.5l.458-2.868c.03-.179.048-.364.052-.556C19.48 10.155 19.21 9.76 18.45 9.76z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3292C8",
    points: "19.43 11.27 19.428 11.283 19.427 11.292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3292C8",
    d: "M22.27,9.76c-1.67,0-2.41,1.273-2.41,2.635c0,1.036,0.43,1.855,1.7,1.855c1.72,0,2.44-1.392,2.44-2.734C24,10.5,23.54,9.76,22.27,9.76z M21.77,13.105c-0.27,0-0.38-0.247-0.38-0.651c0-0.523,0.12-1.559,0.72-1.559c0.26,0,0.35,0.247,0.35,0.592C22.46,12.02,22.33,13.105,21.77,13.105z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmo);
export default __webpack_public_path__ + "static/media/venmo.bdf9858cb0da2ef4bc3f9e46cc698fdf.svg";
export { ForwardRef as ReactComponent };